module.exports = __webpack_public_path__ + "media/images/mailer/confirmation_email_02-a3b81771a6cbee362fffd1aad48579ea.png";